import { PreferenceLanguages } from '@/client'
import { usePreferenceStore } from '@/stores/preferenceStore'
import { DateFormatter } from '@internationalized/date'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'

dayjs.extend(utc)
dayjs.extend(timezone)

export function displayDate(
  date: Date,
  options: {
    dateStyle?: Intl.ResolvedDateTimeFormatOptions['dateStyle']
    timeStyle?: Intl.ResolvedDateTimeFormatOptions['timeStyle']
  } = { dateStyle: 'long', timeStyle: undefined }
) {
  const preferenceStore = usePreferenceStore()
  const dateFormat = preferenceStore.preferences?.date_format

  const languageFormat = ref('de-De')
  const tz = dayjs.tz.guess()

  if (preferenceStore.preferences?.language === PreferenceLanguages.EN) {
    languageFormat.value = 'en-US'
  }

  // If a custom date format is provided, use it
  if (dateFormat) {
    return dayjs(date).tz(tz).format(dateFormat)
  }

  // Fallback to language-based formatting
  const df = new DateFormatter(languageFormat.value, {
    dateStyle: options.dateStyle,
    timeStyle: options.timeStyle,
  })

  const correctedDate = dayjs(date).tz(tz).toDate()
  return df.format(correctedDate)
}
